
















// import React, { useState, useEffect } from 'react';
// import { FaPhone, FaEnvelope, FaBars, FaTimes, FaChevronDown, FaChevronUp } from 'react-icons/fa';
// import logo from '../assets/assets/logo.jpg';
// import { NavLink } from 'react-router-dom';

// const Navbar = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const [activeDropdown, setActiveDropdown] = useState(null);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const closeMenu = () => {
//     if (isMobile) {
//       setIsMenuOpen(false);
//     }
//   };

//   const toggleDropdown = (dropdown) => {
//     if (activeDropdown === dropdown) {
//       setActiveDropdown(null);
//     } else {
//       setActiveDropdown(dropdown);
//     }
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//       if (window.innerWidth >= 768) {
//         setIsMenuOpen(false);
//       }
//     };

//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 10);
//     };

//     window.addEventListener('resize', handleResize);
//     window.addEventListener('scroll', handleScroll);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   const styles = {
//   header: {
//   fontFamily: "'Poppins', 'Segoe UI', sans-serif",
//   background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
//   color: 'white',
//   padding: '1rem 2rem',
//   boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
//   position: 'relative',
//   borderBottom: '3px solid #ffc107',
//   zIndex: 100, // Add this to create a stacking context
// },
//     headerTop: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       padding: '1rem 0',
//       position: 'relative'
//     },
//     logoContainer: {
//       position: 'absolute',
//       left: '2rem',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '1rem',
//       transition: 'all 0.3s ease',
//       ':hover': {
//         transform: 'scale(1.03)'
//       }
//     },
//     logoCircle: {
//       width: '120px',
//       height: '120px',
//       background: 'radial-gradient(circle, #ffc107 0%, #ffab00 100%)',
//       borderRadius: '50%',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       boxShadow: '0 4px 15px rgba(255, 193, 7, 0.4)',
//       border: '2px solid white'
//     },
//     logoText: {
//       fontWeight: 'bold',
//       fontSize: '1.8rem',
//       color: '#0f2027',
//       textShadow: '0 1px 2px rgba(0,0,0,0.1)'
//     },
//     schoolText: {
//       fontSize: '1.2rem',
//       lineHeight: '1.3',
//       fontWeight: '500',
//       textShadow: '0 1px 2px rgba(0,0,0,0.2)'
//     },
//     subtitle: {
//       fontSize: '0.9rem',
//       display: 'block',
//       opacity: '0.9'
//     },
//     instituteName: {
//       margin: '0',
//       fontSize: '2.2rem',
//       textAlign: 'center',
//       textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
//       background: 'linear-gradient(to right, #fff, #ffc107)',
//       WebkitBackgroundClip: 'text',
//       WebkitTextFillColor: 'transparent',
//       fontWeight: '700',
//       letterSpacing: '0.5px'
//     },
//     navContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '2rem'
//     },
//     navigationBar: {
//       backgroundColor: 'rgba(0, 0, 0, 0.2)',
//       borderRadius: '50px',
//       padding: '0.5rem 2rem',
//       marginTop: '1.5rem',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       backdropFilter: 'blur(10px)',
//       border: '1px solid rgba(255, 255, 255, 0.15)',
//       boxShadow: '0 8px 32px rgba(0, 0, 0, 0.18)'
//     },
//     nav: {
//       display: 'flex',
//       gap: '0.5rem',
//       position: 'relative'
//     },
//     navLinks: {
//       display: 'flex',
//       justifyContent: 'center',
//       listStyle: 'none',
//       padding: '0',
//       margin: '0',
//       gap: '0.5rem'
//     },
//     navItem: {
//       color: 'rgba(255, 255, 255, 0.9)',
//       textDecoration: 'none',
//       fontWeight: '500',
//       padding: '0.8rem 1.5rem',
//       borderRadius: '50px',
//       transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
//       position: 'relative',
//       overflow: 'hidden',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.3rem',
//       '::after': {
//         content: '""',
//         position: 'absolute',
//         bottom: '0',
//         left: '0',
//         width: '100%',
//         height: '2px',
//         backgroundColor: '#ffc107',
//         transform: 'scaleX(0)',
//         transformOrigin: 'right',
//         transition: 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)'
//       },
//       ':hover': {
//         color: 'white',
//         backgroundColor: 'rgba(255, 255, 255, 0.1)',
//         '::after': {
//           transform: 'scaleX(1)',
//           transformOrigin: 'left'
//         }
//       }
//     },
//     active: {
//       color: '#0f2027',
//       fontWeight: '600',
//       background: 'linear-gradient(90deg, #ffc107, #ffdb58)',
//       boxShadow: '0 4px 15px rgba(255, 193, 7, 0.4)',
//       '::after': {
//         display: 'none'
//       }
//     },
//     menuButton: {
//       background: 'rgba(255, 255, 255, 0.1)',
//       border: '1px solid rgba(255, 255, 255, 0.3)',
//       color: 'white',
//       fontSize: '1.5rem',
//       cursor: 'pointer',
//       display: 'none',
//       padding: '0.6rem 1rem',
//       borderRadius: '50px',
//       transition: 'all 0.3s ease',
//       backdropFilter: 'blur(5px)',
//       ':hover': {
//         background: 'rgba(255, 255, 255, 0.2)',
//         transform: 'scale(1.05)'
//       }
//     },
//     buttonWrapper: {
//       display: 'flex',
//       gap: '1rem',
//       alignItems: 'center'
//     },
//     blueBtn: {
//       background: 'linear-gradient(90deg, #4facfe 0%, #00f2fe 100%)',
//       color: 'white',
//       border: 'none',
//       padding: '0.8rem 2rem',
//       borderRadius: '50px',
//       cursor: 'pointer',
//       fontWeight: '600',
//       boxShadow: '0 4px 15px rgba(79, 172, 254, 0.4)',
//       transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
//       textTransform: 'uppercase',
//       letterSpacing: '1px',
//       fontSize: '0.85rem',
//       ':hover': {
//         transform: 'translateY(-3px)',
//         boxShadow: '0 8px 25px rgba(79, 172, 254, 0.6)',
//         background: 'linear-gradient(90deg, #4facfe 0%, #00f2fe 70%)'
//       }
//     },
//   mobileNav: {
//   position: 'fixed',
//   top: '0',
//   left: '0',
//   width: '300px',
//   height: '100vh',
//   background: 'linear-gradient(160deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
//   zIndex: '9999', // Changed to very high value
//   padding: '3rem 2rem',
//   display: 'flex',
//   flexDirection: 'column',
//   gap: '0.5rem',
//   transform: isMenuOpen ? 'translateX(0)' : 'translateX(-100%)',
//   transition: 'transform 0.5s cubic-bezier(0.22, 1, 0.36, 1)',
//   boxShadow: '10px 0 50px rgba(0, 0, 0, 0.5)'
// },
//     mobileNavItem: {
//       padding: '1.2rem 1.5rem',
//       borderRadius: '8px',
//       transition: 'all 0.3s ease',
//       color: 'rgba(255, 255, 255, 0.8)',
//       fontWeight: '500',
//       ':hover': {
//         background: 'rgba(255, 255, 255, 0.1)',
//         color: 'white',
//         transform: 'translateX(5px)'
//       }
//     },
//     mobileActive: {
//       color: '#ffdb58',
//       fontWeight: '600',
//       background: 'rgba(255, 219, 88, 0.1)',
//       borderLeft: '4px solid #ffdb58',
//       transform: 'translateX(5px)'
//     },
//  overlay: {
//   position: 'fixed',
//   top: '0',
//   left: '0',
//   width: '100%',
//   height: '100%',
//   backgroundColor: 'rgba(0, 0, 0, 0.8)',
//   zIndex: '9998', // Just below the mobile nav
//   display: isMenuOpen ? 'block' : 'none',
//   backdropFilter: 'blur(5px)',
//   transition: 'opacity 0.5s ease'
// },
//     closeButton: {
//       position: 'absolute',
//       top: '1.5rem',
//       right: '1.5rem',
//       background: 'rgba(255, 255, 255, 0.1)',
//       border: 'none',
//       color: 'white',
//       width: '40px',
//       height: '40px',
//       borderRadius: '50%',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       cursor: 'pointer',
//       transition: 'all 0.3s ease',
//       ':hover': {
//         background: 'rgba(255, 255, 255, 0.2)',
//         transform: 'rotate(90deg)'
//       }
//     },
//     mobileNavHeader: {
//       paddingBottom: '1.5rem',
//       marginBottom: '1rem',
//       borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '1rem'
//     },
//     mobileLogo: {
//       width: '50px',
//       height: '50px',
//       borderRadius: '50%',
//       background: 'linear-gradient(135deg, #ffc107 0%, #ffdb58 100%)',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       color: '#0f2027',
//       fontWeight: 'bold',
//       fontSize: '1.5rem'
//     },
// dropdown: {
//   position: 'absolute',
//   top: '100%',
//   left: '0',
//   backgroundColor: 'rgba(15, 32, 39, 0.95)',
//   borderRadius: '8px',
//   padding: '0.5rem 0',
//   minWidth: '200px',
//   boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
//   zIndex: '9999', // Changed to very high value
//   border: '1px solid rgba(255, 255, 255, 0.1)',
//   backdropFilter: 'blur(10px)',
//   transformOrigin: 'top',
//   transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
//   opacity: '0',
//   visibility: 'hidden',
//   transform: 'translateY(10px)'
// },
//     dropdownVisible: {
//       opacity: '1',
//       visibility: 'visible',
//       transform: 'translateY(0)'
//     },
//     dropdownItem: {
//       padding: '0.8rem 1.5rem',
//       color: 'rgba(255, 255, 255, 0.8)',
//       textDecoration: 'none',
//       display: 'block',
//       transition: 'all 0.2s ease',
//       ':hover': {
//         color: 'white',
//         backgroundColor: 'rgba(255, 255, 255, 0.1)',
//         paddingLeft: '1.8rem'
//       }
//     },
//     dropdownActive: {
//       color: '#ffc107',
//       fontWeight: '500',
//       borderLeft: '3px solid #ffc107'
//     },
//     mobileDropdown: {
//       display: 'flex',
//       flexDirection: 'column',
//       paddingLeft: '1rem',
//       marginTop: '0.5rem',
//       borderLeft: '2px solid rgba(255, 255, 255, 0.1)'
//     },
//     mobileDropdownItem: {
//       padding: '0.8rem 1rem',
//       color: 'rgba(255, 255, 255, 0.7)',
//       textDecoration: 'none',
//       transition: 'all 0.2s ease',
//       ':hover': {
//         color: 'white',
//         paddingLeft: '1.3rem'
//       }
//     },
//     mobileDropdownActive: {
//       color: '#ffdb58',
//       fontWeight: '500'
//     },
//     '@media (max-width: 768px)': {
//       headerTop: {
//         flexDirection: 'column',
//         textAlign: 'center',
//         padding: '1rem 0 0.5rem'
//       },
//       logoContainer: {
//         position: 'static',
//         marginBottom: '0.5rem',
//         justifyContent: 'center'
//       },
//       instituteName: {
//         fontSize: '1.6rem',
//         marginBottom: '0.5rem'
//       },
//       logoCircle: {
//         width: '60px',
//         height: '60px'
//       },
//       logoText: {
//         fontSize: '1.5rem'
//       },
//       schoolText: {
//         fontSize: '1rem'
//       },
//       subtitle: {
//         fontSize: '0.8rem'
//       },
//       navLinks: {
//         display: 'none'
//       },
//       menuButton: {
//         display: 'block'
//       },
//       nav: {
//         display: 'none'
//       },
//       navigationBar: {
//         padding: '0.5rem 1rem',
//         justifyContent: 'center'
//       }
//     },
//     '@media (max-width: 480px)': {
//       header: {
//         padding: '0.8rem 1rem'
//       },
//       instituteName: {
//         fontSize: '1.4rem'
//       },
//       logoCircle: {
//         width: '50px',
//         height: '50px'
//       },
//       logoText: {
//         fontSize: '1.3rem'
//       },
//     }
//   };

//   return (
//     <>
//       <div style={{
//         display: 'flex',
//         justifyContent: 'right',
//         alignItems: 'center',
//         padding: '10px 20px',
//         background: '#1a1a1a',
//         borderBottom: '1px solid #333',
//         fontFamily: "'Inter', sans-serif",
//         color: '#e5e5e5',
//         paddingLeft: '20px',
//       }}>
//         <div style={{
//           display: 'flex',
//           justifyContent: 'right',
//           width: '100%',
//           maxWidth: '1200px',
//           gap: '30px'
//         }}>
//           <a href="tel:9964801008" style={{
//             display: 'flex',
//             alignItems: 'center',
//             textDecoration: 'none',
//             color: 'inherit',
//             position: 'relative',
//             padding: '8px 0',
//             '::after': {
//               content: '""',
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: 0,
//               height: '2px',
//               background: '#3b82f6',
//               transition: 'width 0.3s ease'
//             },
//             ':hover::after': {
//               width: '100%'
//             }
//           }}>
//             <FaPhone style={{
//               color: '#3b82f6',
//               marginRight: '8px',
//               fontSize: '14px'
//             }} />
//             <span>+91 9964801008</span>
//           </a>

//           <a href="mailto:vidyabhushan1008@gmail.com" style={{
//             display: 'flex',
//             alignItems: 'center',
//             textDecoration: 'none',
//             color: 'inherit',
//             position: 'relative',
//             padding: '8px 0',
//             '::after': {
//               content: '""',
//               position: 'absolute',
//               bottom: 0,
//               left: 0,
//               width: 0,
//               height: '2px',
//               background: '#3b82f6',
//               transition: 'width 0.3s ease'
//             },
//             ':hover::after': {
//               width: '100%'
//             }
//           }}>
//             <FaEnvelope style={{
//               color: '#3b82f6',
//               marginRight: '8px',
//               fontSize: '14px'
//             }} />
//             <span>vidyabhushan1008@gmail.com</span>
//           </a>
//         </div>
//       </div>

//       <div style={styles.header}>
//         <div style={styles.headerTop}>
//           <div style={styles.logoContainer}>
//             <div style={styles.logoCircle}>
//               <img
//                 src={logo}
//                 alt="Vidyabhushan Minority Education Institute Logo"
//                 style={{
//                   height: '100%',
//                   width: '100%',
//                   borderRadius: '50%',
//                 }}
//               />
//             </div>
//           </div>
//           <h1 style={styles.instituteName}>Vidyabhushan Minority Education Institute <br />
//             <h2 style={styles.instituteName}>Acharya Shri Vidyabhushan English Medium School, Shedbal</h2>
//           </h1>
//         </div>

//         <div style={styles.navigationBar}>
//           <nav style={styles.nav}>
//             <NavLink
//               to="/"
//               style={({ isActive }) => ({
//                 ...styles.navItem,
//                 ...(isActive && styles.active),
//               })}
//               onClick={closeMenu}
//             >
//               Home
//             </NavLink>

//             {/* About School Dropdown */}
//             <div 
//               style={{ position: 'relative' }}
//               onMouseEnter={() => !isMobile && setActiveDropdown('about')}
//               onMouseLeave={() => !isMobile && setActiveDropdown(null)}
//             >
//               <div 
//                 style={{
//                   ...styles.navItem,
//                   ...(activeDropdown === 'about' && { color: 'white', backgroundColor: 'rgba(255, 255, 255, 0.1)' }),
//                 }}
//                 onClick={() => isMobile && toggleDropdown('about')}
//               >
//                 About School
//                 {activeDropdown === 'about' ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
//               </div>

//               <div 
//                 style={{
//                   ...styles.dropdown,
//                   ...(activeDropdown === 'about' && styles.dropdownVisible),
//                 }}
//               >
//                 <NavLink
//                   to="/about-entities"
//                   style={({ isActive }) => ({
//                     ...styles.dropdownItem,
//                     ...(isActive && styles.dropdownActive),
//                   })}
//                   onClick={closeMenu}
//                 >
//                   About Entities
//                 </NavLink>
//                 <NavLink
//                   to="/board-of-management"
//                   style={({ isActive }) => ({
//                     ...styles.dropdownItem,
//                     ...(isActive && styles.dropdownActive),
//                   })}
//                   onClick={closeMenu}
//                 >
//                   Board of Management
//                 </NavLink>
//                 <NavLink
//                   to="/faculties"
//                   style={({ isActive }) => ({
//                     ...styles.dropdownItem,
//                     ...(isActive && styles.dropdownActive),
//                   })}
//                   onClick={closeMenu}
//                 >
//                   Faculties
//                 </NavLink>
//               </div>
//             </div>

//             <NavLink
//               to="/CBSEDisclosures"
//               style={({ isActive }) => ({
//                 ...styles.navItem,
//                 ...(isActive && styles.active),
//               })}
//               onClick={closeMenu}
//             >
//               CBSE Disclosures
//             </NavLink>

//             {/* Academics Dropdown */}
//             <div 
//               style={{ position: 'relative' }}
//               onMouseEnter={() => !isMobile && setActiveDropdown('academics')}
//               onMouseLeave={() => !isMobile && setActiveDropdown(null)}
//             >
//               <div 
//                 style={{
//                   ...styles.navItem,
//                   ...(activeDropdown === 'academics' && { color: 'white', backgroundColor: 'rgba(255, 255, 255, 0.1)' }),
//                 }}
//                 onClick={() => isMobile && toggleDropdown('academics')}
//               >
//                 Academics
//                 {activeDropdown === 'academics' ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
//               </div>

//               <div 
//                 style={{
//                   ...styles.dropdown,
//                   ...(activeDropdown === 'academics' && styles.dropdownVisible),
//                 }}
//               >
//                 <NavLink
//                   to="/academics/year-plan"
//                   style={({ isActive }) => ({
//                     ...styles.dropdownItem,
//                     ...(isActive && styles.dropdownActive),
//                   })}
//                   onClick={closeMenu}
//                 >
//                   Year Plan
//                 </NavLink>
//                 <NavLink
//                   to="/academics/calendar-of-events"
//                   style={({ isActive }) => ({
//                     ...styles.dropdownItem,
//                     ...(isActive && styles.dropdownActive),
//                   })}
//                   onClick={closeMenu}
//                 >
//                   Calendar of Events
//                 </NavLink>
//                 {/* <NavLink
//                   to="/AcademicStudentView"
//                   style={({ isActive }) => ({
//                     ...styles.dropdownItem,
//                     ...(isActive && styles.dropdownActive),
//                   })}
//                   onClick={closeMenu}
//                 >
//                   Academic View
//                 </NavLink> */}
//               </div>
//             </div>

//             <NavLink
//               to="/gallery"
//               style={({ isActive }) => ({
//                 ...styles.navItem,
//                 ...(isActive && styles.active),
//               })}
//               onClick={closeMenu}
//             >
//               Gallery
//             </NavLink>

//             <NavLink
//               to="/facilities"
//               style={({ isActive }) => ({
//                 ...styles.navItem,
//                 ...(isActive && styles.active),
//               })}
//               onClick={closeMenu}
//             >
//               Facilities
//             </NavLink>
//           </nav>

//           {/* Mobile Menu Button */}
//           <button style={styles.menuButton} onClick={toggleMenu} aria-label="Menu">
//             {isMenuOpen ? <FaTimes /> : <FaBars />}
//           </button>

//           {/* Admin Button - hidden on mobile */}
//           <div style={{
//             ...styles.buttonWrapper,
//             display: isMobile ? 'none' : 'flex',
//           }}>
//             <button
//               onClick={() => window.location.href = '/AdminLogin'}
//               style={styles.blueBtn}
//             >
//               Admin
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Navigation */}
//       <nav style={styles.mobileNav}>
//         <NavLink
//           to="/"
//           style={({ isActive }) => ({
//             ...styles.navItem,
//             ...styles.mobileNavItem,
//             ...(isActive && styles.mobileActive),
//           })}
//           onClick={closeMenu}
//         >
//           Home
//         </NavLink>

//         {/* Mobile About School Dropdown */}
//         <div>
//           <div 
//             style={{
//               ...styles.mobileNavItem,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               ...(activeDropdown === 'about' && styles.mobileActive),
//             }}
//             onClick={() => toggleDropdown('about')}
//           >
//             About School
//             {activeDropdown === 'about' ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
//           </div>

//           {activeDropdown === 'about' && (
//             <div style={styles.mobileDropdown}>
//               <NavLink
//                 to="/about-school/about-entities"
//                 style={({ isActive }) => ({
//                   ...styles.mobileDropdownItem,
//                   ...(isActive && styles.mobileDropdownActive),
//                 })}
//                 onClick={closeMenu}
//               >
//                 About Entities
//               </NavLink>
//               <NavLink
//                 to="/about-school/board-of-management"
//                 style={({ isActive }) => ({
//                   ...styles.mobileDropdownItem,
//                   ...(isActive && styles.mobileDropdownActive),
//                 })}
//                 onClick={closeMenu}
//               >
//                 Board of Management
//               </NavLink>
//               <NavLink
//                 to="/about-school/faculties"
//                 style={({ isActive }) => ({
//                   ...styles.mobileDropdownItem,
//                   ...(isActive && styles.mobileDropdownActive),
//                 })}
//                 onClick={closeMenu}
//               >
//                 Faculties
//               </NavLink>
//             </div>
//           )}
//         </div>

//         <NavLink
//           to="/CBSEDisclosures"
//           style={({ isActive }) => ({
//             ...styles.navItem,
//             ...styles.mobileNavItem,
//             ...(isActive && styles.mobileActive),
//           })}
//           onClick={closeMenu}
//         >
//           CBSE Disclosures
//         </NavLink>

//         {/* Mobile Academics Dropdown */}
//         <div>
//           <div 
//             style={{
//               ...styles.mobileNavItem,
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               ...(activeDropdown === 'academics' && styles.mobileActive),
//             }}
//             onClick={() => toggleDropdown('academics')}
//           >
//             Academics
//             {activeDropdown === 'academics' ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
//           </div>

//           {activeDropdown === 'academics' && (
//             <div style={styles.mobileDropdown}>
//               <NavLink
//                 to="/academics/year-plan"
//                 style={({ isActive }) => ({
//                   ...styles.mobileDropdownItem,
//                   ...(isActive && styles.mobileDropdownActive),
//                 })}
//                 onClick={closeMenu}
//               >
//                 Year Plan
//               </NavLink>
//               <NavLink
//                 to="/academics/calendar-of-events"
//                 style={({ isActive }) => ({
//                   ...styles.mobileDropdownItem,
//                   ...(isActive && styles.mobileDropdownActive),
//                 })}
//                 onClick={closeMenu}
//               >
//                 Calendar of Events
//               </NavLink>
//               <NavLink
//                 to="/AcademicStudentView"
//                 style={({ isActive }) => ({
//                   ...styles.mobileDropdownItem,
//                   ...(isActive && styles.mobileDropdownActive),
//                 })}
//                 onClick={closeMenu}
//               >
//                 Academic View
//               </NavLink>
//             </div>
//           )}
//         </div>

//         <NavLink
//           to="/gallery"
//           style={({ isActive }) => ({
//             ...styles.navItem,
//             ...styles.mobileNavItem,
//             ...(isActive && styles.mobileActive),
//           })}
//           onClick={closeMenu}
//         >
//           Gallery
//         </NavLink>

//         <NavLink
//           to="/facilities"
//           style={({ isActive }) => ({
//             ...styles.navItem,
//             ...styles.mobileNavItem,
//             ...(isActive && styles.mobileActive),
//           })}
//           onClick={closeMenu}
//         >
//           Facilities
//         </NavLink>

//         {/* Admin Button in mobile menu */}
//         <button
//           onClick={() => {
//             window.location.href = '/AdminLogin';
//             closeMenu();
//           }}
//           style={{
//             ...styles.blueBtn,
//             marginTop: '1rem',
//             width: '100%',
//             textAlign: 'center'
//           }}
//         >
//           Admin
//         </button>
//       </nav>

//       {/* Overlay for mobile menu */}
//       {isMenuOpen && (
//         <div
//           style={styles.overlay}
//           onClick={closeMenu}
//           aria-hidden="true"
//         />
//       )}
//     </>
//   );
// };

// export default Navbar;
































import React, { useState, useEffect } from 'react';
import { FaPhone, FaEnvelope, FaBars, FaTimes, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import logo from '../assets/assets/newlogo.jpeg';
import { NavLink, useNavigate } from 'react-router-dom';


import Notify from './Notify';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const navigate = useNavigate();


  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    if (isMobile) {
      setIsMenuOpen(false);
    }
  };

  const toggleDropdown = (dropdown) => {
    if (activeDropdown === dropdown) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(dropdown);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setIsMenuOpen(false);
      }
    };

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const getStyles = (isMenuOpen) => ({
    header: {
      fontFamily: "'Poppins', 'Segoe UI', sans-serif",
      background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
      color: 'white',
      padding: isMobile ? '0.8rem 1rem' : '1rem 2rem',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      position: 'relative',
      borderBottom: '3px solid #ffc107',
      zIndex: 100,
    },
    headerTop: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: isMobile ? '0.5rem 1rem' : '1rem 2rem',
      position: 'relative',
      flexDirection: isMobile ? 'column' : 'row',
      textAlign: 'center',
    },
    logoContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: isMobile ? '0.5rem' : '1rem',
      transition: 'all 0.3s ease',
      marginBottom: isMobile ? '1rem' : '0',
      marginRight: isMobile ? '0' : '2rem',
      justifyContent: isMobile ? 'center' : 'flex-start',
      flexShrink: 0,
      ':hover': {
        transform: 'scale(1.03)'
      }
    },
    logoCircle: {
      width: isMobile ? (window.innerWidth < 480 ? '50px' : '60px') : '140px',
      height: isMobile ? (window.innerWidth < 480 ? '50px' : '60px') : '140px',
      // background: 'radial-gradient(circle, #ffc107 0%, #ffab00 100%)',
      // borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // boxShadow: '0 4px 15px rgba(255, 193, 7, 0.4)',
      // border: '2px solid white'
    },
    logoText: {
      fontWeight: 'bold',
      fontSize: isMobile ? (window.innerWidth < 480 ? '1.3rem' : '1.5rem') : '1.8rem',
      color: '#0f2027',
      textShadow: '0 1px 2px rgba(0,0,0,0.1)'
    },
    schoolText: {
      fontSize: isMobile ? (window.innerWidth < 480 ? '0.8rem' : '1rem') : '1.2rem',
      lineHeight: '1.3',
      fontWeight: '500',
      textShadow: '0 1px 2px rgba(0,0,0,0.2)'
    },
    subtitle: {
      fontSize: isMobile ? (window.innerWidth < 480 ? '0.65rem' : '0.8rem') : '0.9rem',
      display: 'block',
      opacity: '0.9'
    },
    instituteName: {
      margin: '0',
      fontSize: isMobile ? 'clamp(1.2rem, 5vw, 1.6rem)' : '1.8rem',
      textAlign: 'center',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
      background: 'linear-gradient(to right, #fff, #ffc107)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      fontWeight: '700',
      letterSpacing: '0.5px',
      marginBottom: isMobile ? '0.4rem' : '0',
    },

    navContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '2rem'
    },
    navigationBar: {
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      borderRadius: '50px',
      padding: isMobile ? '0.3rem' : '0.5rem 2rem',
      marginTop: isMobile ? '0.5rem' : '1.5rem',
      display: 'flex',
      justifyContent: isMobile ? 'center' : 'space-between',
      alignItems: 'center',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.15)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.18)'
    },
    nav: {
      display: isMobile ? 'none' : 'flex',
      gap: '0.5rem',
      position: 'relative'
    },
    navLinks: {
      display: 'flex',
      justifyContent: 'center',
      listStyle: 'none',
      padding: '0',
      margin: '0',
      gap: '0.5rem'
    },
    navItem: {
      color: 'rgba(255, 255, 255, 0.9)',
      textDecoration: 'none',
      fontWeight: '500',
      padding: isMobile ? '0.8rem 1rem' : '0.8rem 1.5rem',
      borderRadius: '50px',
      transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      gap: '0.3rem',
      fontSize: isMobile ? '0.9rem' : '1rem',
      '::after': {
        content: '""',
        position: 'absolute',
        bottom: '0',
        left: '0',
        width: '100%',
        height: '2px',
        backgroundColor: '#ffc107',
        transform: 'scaleX(0)',
        transformOrigin: 'right',
        transition: 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)'
      },
      ':hover': {
        color: 'white',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        '::after': {
          transform: 'scaleX(1)',
          transformOrigin: 'left'
        }
      }
    },
    active: {
      color: '#0f2027',
      fontWeight: '600',
      background: 'linear-gradient(90deg, #ffc107, #ffdb58)',
      boxShadow: '0 4px 15px rgba(255, 193, 7, 0.4)',
      '::after': {
        display: 'none'
      }
    },
    menuButton: {
      background: 'rgba(255, 255, 255, 0.1)',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      color: 'white',
      fontSize: isMobile ? '1.1rem' : '1.5rem',
      cursor: 'pointer',
      display: isMobile ? 'block' : 'none',
      padding: isMobile ? '0.4rem 0.7rem' : '0.6rem 1rem',
      borderRadius: '50px',
      transition: 'all 0.3s ease',
      backdropFilter: 'blur(5px)',
      ':hover': {
        background: 'rgba(255, 255, 255, 0.2)',
        transform: 'scale(1.05)'
      }
    },
    buttonWrapper: {
      display: 'flex',
      gap: '1rem',
      alignItems: 'center'
    },
    blueBtn: {
      background: 'linear-gradient(90deg, #4facfe 0%, #00f2fe 100%)',
      color: 'white',
      border: 'none',
      padding: isMobile ? '0.5rem 1rem' : '0.8rem 2rem',
      borderRadius: '50px',
      cursor: 'pointer',
      fontWeight: '600',
      boxShadow: '0 4px 15px rgba(79, 172, 254, 0.4)',
      transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      fontSize: isMobile ? '0.7rem' : '0.85rem',
      ':hover': {
        transform: 'translateY(-3px)',
        boxShadow: '0 8px 25px rgba(79, 172, 254, 0.6)',
        background: 'linear-gradient(90deg, #4facfe 0%, #00f2fe 70%)'
      }
    },
    mobileNav: {
      position: 'fixed',
      top: '0',
      left: '0',
      width: isMobile ? (window.innerWidth < 480 ? '85%' : '300px') : '300px',
      height: '100vh',
      background: 'linear-gradient(160deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
      zIndex: 1000,
      padding: '2rem 1.5rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      transform: isMenuOpen ? 'translateX(0)' : 'translateX(-100%)',
      transition: 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)',
      boxShadow: '10px 0 50px rgba(0, 0, 0, 0.5)',
      overflowY: 'auto'
    },
    mobileNavItem: {
      padding: '1.2rem 1.5rem',
      borderRadius: '8px',
      transition: 'all 0.3s ease',
      color: 'rgba(255, 255, 255, 0.8)',
      fontWeight: '500',
      ':hover': {
        background: 'rgba(255, 255, 255, 0.1)',
        color: 'white',
        transform: 'translateX(5px)'
      }
    },
    mobileActive: {
      color: '#ffdb58',
      fontWeight: '600',
      background: 'rgba(255, 219, 88, 0.1)',
      borderLeft: '4px solid #ffdb58',
      transform: 'translateX(5px)'
    },
    overlay: {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      zIndex: 999,
      display: isMenuOpen ? 'block' : 'none',
      backdropFilter: 'blur(5px)'
    },
    closeButton: {
      position: 'absolute',
      top: '1.5rem',
      right: '1.5rem',
      background: 'rgba(255, 255, 255, 0.1)',
      border: 'none',
      color: 'white',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      ':hover': {
        background: 'rgba(255, 255, 255, 0.2)',
        transform: 'rotate(90deg)'
      }
    },
    mobileNavHeader: {
      paddingBottom: '1.5rem',
      marginBottom: '1rem',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      display: 'flex',
      alignItems: 'center',
      gap: '1rem'
    },
    mobileLogo: {
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #ffc107 0%, #ffdb58 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#0f2027',
      fontWeight: 'bold',
      fontSize: '1.5rem'
    },
    dropdown: {
      position: 'absolute',
      top: '100%',
      left: '0',
      backgroundColor: 'rgba(15, 32, 39, 0.95)',
      borderRadius: '8px',
      padding: '0.5rem 0',
      minWidth: '200px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
      zIndex: 1000,
      border: '1px solid rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(10px)',
      transformOrigin: 'top',
      transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
      opacity: '0',
      visibility: 'hidden',
      transform: 'translateY(10px)'
    },
    dropdownVisible: {
      opacity: '1',
      visibility: 'visible',
      transform: 'translateY(0)'
    },
    dropdownItem: {
      padding: '0.8rem 1.5rem',
      color: 'rgba(255, 255, 255, 0.8)',
      textDecoration: 'none',
      display: 'block',
      transition: 'all 0.2s ease',
      ':hover': {
        color: 'white',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        paddingLeft: '1.8rem'
      }
    },
    dropdownActive: {
      color: '#ffc107',
      fontWeight: '500',
      borderLeft: '3px solid #ffc107'
    },
    mobileDropdown: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: '1rem',
      marginTop: '0.5rem',
      borderLeft: '2px solid rgba(255, 255, 255, 0.1)'
    },
    mobileDropdownItem: {
      padding: '0.8rem 1rem',
      color: 'rgba(255, 255, 255, 0.7)',
      textDecoration: 'none',
      transition: 'all 0.2s ease',
      ':hover': {
        color: 'white',
        paddingLeft: '1.3rem'
      }
    },
    mobileDropdownActive: {
      color: '#ffdb58',
      fontWeight: '500'
    },
  });

  const styles = getStyles(isMenuOpen);

  return (
    <>
      <div style={{
        display: 'flex',
        justifyContent: 'right',
        alignItems: 'center',
        padding: '10px 20px',
        background: '#1a1a1a',
        borderBottom: '1px solid #333',
        fontFamily: "'Inter', sans-serif",
        color: '#e5e5e5',
        paddingLeft: '20px',
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'right',
          width: '100%',
          maxWidth: '1200px',
          gap: isMobile ? '15px' : '30px',
          flexWrap: isMobile ? 'wrap' : 'nowrap',
          fontSize: isMobile ? '0.8rem' : '1rem',
        }}>
          <a href="tel:9964801008" style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            color: 'inherit',
            position: 'relative',
            padding: '8px 0',
            '::after': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: 0,
              height: '2px',
              background: '#3b82f6',
              transition: 'width 0.3s ease'
            },
            ':hover::after': {
              width: '100%'
            }
          }}>
            <FaPhone style={{
              color: '#3b82f6',
              marginRight: '8px',
              fontSize: isMobile ? '12px' : '14px'
            }} />
            <span>+91 9964801008</span>
          </a>

          <a href="mailto:vidyabhushan1008@gmail.com" style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            color: 'inherit',
            position: 'relative',
            padding: '8px 0',
            '::after': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: 0,
              height: '2px',
              background: '#3b82f6',
              transition: 'width 0.3s ease'
            },
            ':hover::after': {
              width: '100%'
            }
          }}>
            <FaEnvelope style={{
              color: '#3b82f6',
              marginRight: '8px',
              fontSize: isMobile ? '12px' : '14px'
            }} />
            <span>vidyabhushan1008@gmail.com</span>
          </a>
        </div>
      </div>

      <div style={styles.header}>
        <div style={styles.headerTop}>
          <div style={styles.logoContainer}>
            <div style={styles.logoCircle}>
              <img
                src={logo}
                alt="Vidyabhushan Minority Education Institute Logo"
                style={{
                  height: '100%',
                  width: '100%',
                  borderRadius: '50%',
                }}
              />
            </div>
          </div>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <h1 style={styles.instituteName}>Vidyabhushan Minority Educational Institute</h1>
            <h2 style={{
              ...styles.instituteName,
              fontSize: isMobile ? 'clamp(1rem, 4vw, 1.4rem)' : '1.5rem',
              color: '#ffc107',
              WebkitTextFillColor: 'initial',
              background: 'none',
              textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
              marginTop: '5px'
            }}>
              ACHARYA SHRI VIDYANAND ENGLISH MEDIUM SCHOOL, SHEDBAL - 591315
            </h2>

            <h3 style={{
              marginTop: '10px',
              fontSize: isMobile ? '0.9rem' : '1.1rem',
              fontWeight: '500',
              display: 'flex',
              justifyContent: 'center',
              gap: isMobile ? '10px' : '30px',
              flexWrap: 'wrap',
              margin: '10px 0 0 0'
            }}>
              <span>Tq: Kagwad</span>
              <span style={isMobile ? {} : { borderLeft: '2px solid rgba(255,255,255,0.3)', borderRight: '2px solid rgba(255,255,255,0.3)', padding: '0 30px' }}>Dise Code: 29301303308</span>
              <span>Dist: Belagavi</span>
            </h3>
          </div>
        </div>


        <div style={styles.navigationBar}>
          <nav style={styles.nav}>
            <NavLink
              to="/"
              style={({ isActive }) => ({
                ...styles.navItem,
                ...(isActive && styles.active),
              })}
              onClick={closeMenu}
            >
              Home
            </NavLink>

            {/* About School Dropdown */}
            <div
              style={{ position: 'relative' }}
              onMouseEnter={() => !isMobile && setActiveDropdown('about')}
              onMouseLeave={() => !isMobile && setActiveDropdown(null)}
            >
              <div
                style={{
                  ...styles.navItem,
                  ...(activeDropdown === 'about' && { color: 'white', backgroundColor: 'rgba(255, 255, 255, 0.1)' }),
                }}
                onClick={() => isMobile && toggleDropdown('about')}
              >
                About School
                {activeDropdown === 'about' ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
              </div>

              <div
                style={{
                  ...styles.dropdown,
                  ...(activeDropdown === 'about' && styles.dropdownVisible),
                }}
              >
                <NavLink
                  to="/about-entities"
                  style={({ isActive }) => ({
                    ...styles.dropdownItem,
                    ...(isActive && styles.dropdownActive),
                  })}
                  onClick={closeMenu}
                >
                  About Institute
                </NavLink>
                <NavLink
                  to="/board-of-management"
                  style={({ isActive }) => ({
                    ...styles.dropdownItem,
                    ...(isActive && styles.dropdownActive),
                  })}
                  onClick={closeMenu}
                >
                  Board of Management
                </NavLink>
                <NavLink
                  to="/faculties"
                  style={({ isActive }) => ({
                    ...styles.dropdownItem,
                    ...(isActive && styles.dropdownActive),
                  })}
                  onClick={closeMenu}
                >
                  Faculties
                </NavLink>
              </div>
            </div>

            <NavLink
              to="/CBSEDisclosures"
              style={({ isActive }) => ({
                ...styles.navItem,
                ...(isActive && styles.active),
              })}
              onClick={closeMenu}
            >
              CBSE Disclosures
            </NavLink>

            {/* Academics Dropdown */}
            <div
              style={{ position: 'relative' }}
              onMouseEnter={() => !isMobile && setActiveDropdown('academics')}
              onMouseLeave={() => !isMobile && setActiveDropdown(null)}
            >
              <div
                style={{
                  ...styles.navItem,
                  ...(activeDropdown === 'academics' && { color: 'white', backgroundColor: 'rgba(255, 255, 255, 0.1)' }),
                }}
                onClick={() => isMobile && toggleDropdown('academics')}
              >
                Academics
                {activeDropdown === 'academics' ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
              </div>

              <div
                style={{
                  ...styles.dropdown,
                  ...(activeDropdown === 'academics' && styles.dropdownVisible),
                }}
              >
                <NavLink
                  to="/AcademicStudentView"
                  style={({ isActive }) => ({
                    ...styles.dropdownItem,
                    ...(isActive && styles.dropdownActive),
                  })}
                  onClick={closeMenu}
                >
                  Year Plan
                </NavLink>
                <NavLink
                  to="/Calender"
                  style={({ isActive }) => ({
                    ...styles.dropdownItem,
                    ...(isActive && styles.dropdownActive),
                  })}
                  onClick={closeMenu}
                >
                  Calendar of Events
                </NavLink>
              </div>
            </div>

            <NavLink
              to="/gallery"
              style={({ isActive }) => ({
                ...styles.navItem,
                ...(isActive && styles.active),
              })}
              onClick={closeMenu}
            >
              Gallery
            </NavLink>

            <NavLink
              to="/facilities"
              style={({ isActive }) => ({
                ...styles.navItem,
                ...(isActive && styles.active),
              })}
              onClick={closeMenu}
            >
              Facilities
            </NavLink>
          </nav>

          {/* Mobile Menu Button */}
          <button style={styles.menuButton} onClick={toggleMenu} aria-label="Menu">
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>

          {/* Admin Button - hidden on mobile */}
          <div style={{
            ...styles.buttonWrapper,
            display: isMobile ? 'none' : 'flex',
          }}>
            <button
              onClick={() => window.location.href = '/AdminLogin'}
              style={styles.blueBtn}
            >
              Admin
            </button>
          </div>
        </div>


      </div>
      <Notify />

      {/* Mobile Navigation */}
      <nav style={styles.mobileNav}>
        <NavLink
          to="/"
          style={({ isActive }) => ({
            ...styles.navItem,
            ...styles.mobileNavItem,
            ...(isActive && styles.mobileActive),
          })}
          onClick={closeMenu}
        >
          Home
        </NavLink>

        {/* Mobile About School Dropdown */}
        <div>
          <div
            style={{
              ...styles.mobileNavItem,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              ...(activeDropdown === 'about' && styles.mobileActive),
            }}
            onClick={() => toggleDropdown('about')}
          >
            About School
            {activeDropdown === 'about' ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
          </div>

          {activeDropdown === 'about' && (
            <div style={styles.mobileDropdown}>
              <NavLink
                to="/about-entities"
                style={({ isActive }) => ({
                  ...styles.mobileDropdownItem,
                  ...(isActive && styles.mobileDropdownActive),
                })}
                onClick={closeMenu}
              >
                About Entities
              </NavLink>
              <NavLink
                to="/board-of-management"
                style={({ isActive }) => ({
                  ...styles.mobileDropdownItem,
                  ...(isActive && styles.mobileDropdownActive),
                })}
                onClick={closeMenu}
              >
                Board of Management
              </NavLink>
              <NavLink
                to="/Faculties"
                style={({ isActive }) => ({
                  ...styles.mobileDropdownItem,
                  ...(isActive && styles.mobileDropdownActive),
                })}
                onClick={closeMenu}
              >
                Faculties
              </NavLink>
            </div>
          )}
        </div>

        <NavLink
          to="/CBSEDisclosures"
          style={({ isActive }) => ({
            ...styles.navItem,
            ...styles.mobileNavItem,
            ...(isActive && styles.mobileActive),
          })}
          onClick={closeMenu}
        >
          CBSE Disclosures
        </NavLink>

        {/* Mobile Academics Dropdown */}
        <div>
          <div
            style={{
              ...styles.mobileNavItem,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              ...(activeDropdown === 'academics' && styles.mobileActive),
            }}
            onClick={() => toggleDropdown('academics')}
          >
            Academics
            {activeDropdown === 'academics' ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
          </div>

          {activeDropdown === 'academics' && (
            <div style={styles.mobileDropdown}>
              <NavLink
                to="/AcademicStudentView"
                style={({ isActive }) => ({
                  ...styles.mobileDropdownItem,
                  ...(isActive && styles.mobileDropdownActive),
                })}
                onClick={closeMenu}
              >
                Year Plan
              </NavLink>
              <NavLink
                to="/Calender"
                style={({ isActive }) => ({
                  ...styles.mobileDropdownItem,
                  ...(isActive && styles.mobileDropdownActive),
                })}
                onClick={closeMenu}
              >
                Calendar of Events
              </NavLink>

            </div>
          )}
        </div>

        <NavLink
          to="/gallery"
          style={({ isActive }) => ({
            ...styles.navItem,
            ...styles.mobileNavItem,
            ...(isActive && styles.mobileActive),
          })}
          onClick={closeMenu}
        >
          Gallery
        </NavLink>

        <NavLink
          to="/facilities"
          style={({ isActive }) => ({
            ...styles.navItem,
            ...styles.mobileNavItem,
            ...(isActive && styles.mobileActive),
          })}
          onClick={closeMenu}
        >
          Facilities
        </NavLink>

        {/* Admin Button in mobile menu */}
        <button
          onClick={() => {
            navigate('/AdminLogin');
            closeMenu();
          }}
          style={{
            ...styles.blueBtn,
            marginTop: '1rem',
            width: '100%',
            textAlign: 'center'
          }}
        >
          Admin
        </button>
      </nav>

      {/* Overlay for mobile menu */}
      {isMenuOpen && (
        <div
          style={styles.overlay}
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default Navbar;